import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import GlobalStyle from "../templates/globalStyle";
import { ToastProvider } from "../toast";

type Props = {
  children: React.ReactNode;
};

export default function RootElement({ children }: Props) {
  const [queryClient] = React.useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <GlobalStyle />
      <ToastProvider>{children}</ToastProvider>
    </QueryClientProvider>
  );
}
